export default class TestCatalogueObject {
  public someField: string;
  constructor(someField: string) {
    this.someField = someField;
  }
}
